import { useEffect, useState } from 'react';
import { logisticsOpsApi } from '../api/logisticsOps';

let cache = null;
let inflight = null;

export function __resetFeatureConfigCache() {
  cache = null;
  inflight = null;
}

export function useFeatureConfig() {
  const [config, setConfig] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let active = true;

    if (cache) {
      setConfig(cache);
      setLoading(false);
      return undefined;
    }

    inflight =
      inflight ||
      logisticsOpsApi
        .getFeatureConfig()
        .then((c) => {
          cache = {
            logisticsOpsEnabled: !!(c && c.logisticsOpsEnabled),
            assetMgmtEnabled: !!(c && c.assetMgmtEnabled),
            wmsEnabled: !!(c && c.wmsEnabled),
            // GS1 e o padrao, e tambem o fallback quando a chamada falha: uma
            // configuracao indisponivel nao pode ligar o modo opaco sozinha.
            identityMode: (c && c.identityMode) === 'OPAQUE' ? 'OPAQUE' : 'GS1',
          };
          return cache;
        })
        .catch(() => {
          cache = { logisticsOpsEnabled: false, assetMgmtEnabled: false, wmsEnabled: false, identityMode: 'GS1' };
          return cache;
        });

    inflight.then((c) => {
      if (active) {
        setConfig(c);
        setLoading(false);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return {
    logisticsOpsEnabled: !!(config && config.logisticsOpsEnabled),
    assetMgmtEnabled: !!(config && config.assetMgmtEnabled),
    wmsEnabled: !!(config && config.wmsEnabled),
    identityMode: (config && config.identityMode) || 'GS1',
    opaqueIdentity: !!(config && config.identityMode === 'OPAQUE'),
    loading,
  };
}
